'use client';

import PcCategoryFilterItem from '@/shared/ui/category-filter/PcCategoryFilterItem';

interface CategoryFilterGroupProps<T> {
  items: T[];
  selectedId: number | string;
  getItemId: (item: T) => number | string;
  getItemLabel: (item: T) => string;
  onSelect?: (item: T) => void;
}

const PcCategoryFilterGroup = <T,>({
  items,
  selectedId,
  getItemId,
  getItemLabel,
  onSelect,
}: CategoryFilterGroupProps<T>) => {
  return (
    <>
      {items.map((item) => (
        <PcCategoryFilterItem
          key={getItemId(item)}
          item={item}
          isSelected={selectedId === getItemId(item)}
          label={getItemLabel(item)}
          onClick={onSelect}
        />
      ))}
    </>
  );
};

export default PcCategoryFilterGroup;
